import { render, staticRenderFns } from "./sanyayom.vue?vue&type=template&id=2ce36401&"
import script from "./sanyayom.vue?vue&type=script&lang=js&"
export * from "./sanyayom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports